





















import {Component, Prop, Vue} from 'vue-property-decorator'
import ListSorter from "@/components/ListSorter/ListSorter.vue";
import ScheduleListSorter from "@/components/ListSorter/ScheduleListSorter.vue";
@Component({
    components: {ScheduleListSorter, ListSorter}
})
export default class DEBUG_PAGE extends Vue {

    private ids = [1, 2, 3, 4];

    private onSortChange(ids: number[]) {
        this.ids = ids;
    }

    async beforeCreate() {
        console.log("start 1111")
        await new Promise((resolve => setTimeout((_: any) => resolve(), 2000)));
        console.log("end  1111")
    }

    async created() {
        console.log("start  2222")
        await new Promise((resolve => setTimeout((_: any) => resolve(), 1999)));
        console.log("end  2222")

    }

    async mounted() {
        console.log("start  3333")
        await new Promise((resolve => setTimeout((_: any) => resolve(), 1998)));
        console.log("end  3333")
    }

}
